<template>
  <ImageUpload
    v-model="organizerLogo"
    class="col-2"
    :disabled="!hasOrganizer || isOrganizerDisabled"
    :label="$t('_web_tournament_logo-label', 'Logo')"
    name="organizer-logo"
    :width="1"
    :height="1"
  />
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ImageUpload from '@/components/form/ImageUpload';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentOrganizerLogoSetting',
  inject: ['$validator'],
  components: {
    ImageUpload,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      titleCopy: '',
    };
  },
  computed: {
    ...mapState('my', ['account']),
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    hasOrganizer() {
      return this.$lodash.get(
        this.currentTournament,
        'info.event_organizer.isAvailable',
        true
      );
    },
    isOrganizerDisabled() {
      return this.isTournamentFieldDisabled('event_organizer');
    },
    organizerLogo: {
      get() {
        const eventOrganizer = this.$lodash.get(
          this.currentTournament,
          'info.event_organizer',
          {}
        );
        return (
          eventOrganizer.helper_logo ||
          eventOrganizer.logo ||
          (this.hasOrganizer && this.account._avatar) ||
          ''
        );
      },
      set(newVal) {
        if (newVal) {
          this.updateEventOrganizer(
            'uploaded_manually',
            newVal !== this.account._avatar
          );
        }
        this.updateEventOrganizer(
          'helper_logo',
          newVal ? newVal.display_uri : null
        );
        this.updateEventOrganizer('logo', newVal ? newVal.file_id : null);
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    updateEventOrganizer(key, val) {
      const event_organizer = this.$lodash.cloneDeep(
        this.currentTournament.info.event_organizer
      );
      event_organizer[key] = val;
      this.updateCurrentTournament({
        event_organizer,
        component: 'info',
      });
    },
  },
};
</script>
